import { render, staticRenderFns } from "./Groups.vue?vue&type=template&id=79939eb2&scoped=true"
import script from "./Groups.js?vue&type=script&lang=js&external"
export * from "./Groups.js?vue&type=script&lang=js&external"
import style0 from "./Groups.vue?vue&type=style&index=0&id=79939eb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79939eb2",
  null
  
)

export default component.exports